import React, { useState } from "react";
import { Heart } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useWishlist } from "../context/WishlistContext";
import { toast } from "sonner";

/**
 * Heart-icon button to toggle wishlist for a product or vehicle.
 * Wishlist state comes from WishlistContext (one request per page, not one per card).
 */
export default function WishlistButton({ productId, vehicleId, testId, className = "" }) {
    const { user } = useAuth();
    const wishlist = useWishlist();
    const [busy, setBusy] = useState(false);
    const active = !!user && !!wishlist?.has(productId, vehicleId);

    const toggle = async (e) => {
        e.preventDefault(); e.stopPropagation();
        if (!user) { toast("Sign in to use your wishlist."); return; }
        setBusy(true);
        try {
            const added = await wishlist.toggle(productId, vehicleId);
            if (added) toast.success("Added to wishlist");
        } catch { toast.error("Wishlist update failed"); }
        setBusy(false);
    };

    return (
        <button
            type="button"
            onClick={toggle}
            disabled={busy}
            data-testid={testId || "wishlist-btn"}
            className={`w-9 h-9 flex items-center justify-center bg-[#F7F3EB]/90 backdrop-blur border border-[#E2D4C1] hover:border-gold transition-colors ${active ? "text-gold" : "text-[#33302C]"} ${className}`}
            aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
            aria-pressed={active}
        >
            <Heart size={14} fill={active ? "currentColor" : "none"} />
        </button>
    );
}
